import { makeAutoObservable } from "mobx";
import { SearchObject } from "app/common/Model/SearchObject";
import { toast } from "react-toastify";
import { PageResponse } from "app/common/Model/Shared";
import {
  getHospitalBedSVRequestById,
  getListPaServiceRes,
  pagingServiceItem,
  saveServiceItem,
  voidSvitemAndOrther,
} from "app/services/ServiceRequestItemService";
import { RegisterService } from "app/common/Model/RegisterService";
import { getPriceTypeService } from "app/common/LocalFunction";
import { pagingRegisterServiceHistory } from "app/services/RegisterServiceHistoryService";

export default class RegisterServiceStore {
  searchRegisterService = {
    ...new SearchObject(),
    fromDate: new Date(new Date().getFullYear(), 0, 1),
    toDate: new Date(),
  };
  pageRegisterService = new PageResponse();
  openCreateOrEditServicePopup = false;
  openAddServiceAdvicePopup = false;
  openUpdateServiceAdvicePopup = false;
  initRegisterService = { ...new RegisterService() };
  searchListPaServiceRes = {
    ...new SearchObject(),
    fromDate: new Date(),
    toDate: new Date(),
  };

  dataRegisterService = new PageResponse();

  openConfirmDelete = null;
  openConfirmMessage = null;
  openConfirmDeleteMessage = null;
  isSelectingForPrint = false;
  openPrintService = false;
  selectedRowService = null;
  openRegisterServiceHistoryPopup = false;
  selectRegisterServiceId = null;
  dataRegisterServiceHistory = null;

  searchRegisterServiceHistory = {
    ...new SearchObject(),
    patientServiceRegisterId: null
  };

  constructor() {
    makeAutoObservable(this);
  }

  pagingRegisterService = async () => {
    let { healthCareSvId, groupId, departmentId, ...ortherData } =
      this.searchRegisterService;
    if (healthCareSvId) {
      ortherData.healthCareSvId = healthCareSvId?.id;
    }
    if (groupId) {
      ortherData.groupId = groupId?.id;
    }
    if (departmentId) {
      ortherData.departmentId = departmentId?.id;
    }
    return await pagingServiceItem({ ...ortherData, getStaffRevenues: true })
      .then(({ data }) => {
        this.pageRegisterService = data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu tư vấn khách hàng có lỗi");
      });
  };

  pagingRegisterServiceAdvice = async () => {
    return await getListPaServiceRes({ ...this.searchListPaServiceRes })
      .then(({ data }) => {
        this.dataRegisterService = data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu tư vấn khách hàng có lỗi");
      });
  };

  setOpenPopupPrintService = (state) => {
    this.openPrintService = state;
  };

  setSelectedRowService = (row) => {
    this.selectedRowService = row;
  };

  handleClosePrintService = () => {
    this.openPrintService = false;
    this.selectedRowService = null;
  };

  saveOrUpdateRegisterService = async (values) => {
    return await saveServiceItem(values)
      .then(({ data }) => {
        if (data?.responseStatus === false) {
          setTimeout(() => {
            this.openConfirmMessage = data?.responseDetail;
          }, 500);
          return;
        } else {
          toast.success("Đăng ký dịch vụ thành công");
          this.pagingRegisterService();
          this.openCreateOrEditServicePopup = false;
        }
      })
      .catch((error) => {
        console.error(error);
        let message = "Lưu thông tin đăng ký dịch vụ có lỗi";
        if (error?.response?.data?.message) {
          message = error.response.data.message;
        } else if (typeof error?.response?.data === "string" && error.response.data) {
          message = error.response.data;
        } else if (error?.message) {
          message = error.message;
        }
        toast.error(message);
      });
  };

  saveOrUpdateServiceAdvice = async (values) => {
    return await saveServiceItem(values)
      .then(({ data }) => {
        this.openUpdateServiceAdvicePopup = false;
        toast.success("Đăng ký dịch vụ từ tư vấn thành công");
        this.pagingRegisterServiceAdvice();
      })
      .catch((error) => {
        console.error(error);
        let message = "Lưu thông tin đăng ký dịch vụ từ tư vấn có lỗi";
        if (error?.response?.data?.message) {
          message = error.response.data.message;
        } else if (typeof error?.response?.data === "string" && error.response.data) {
          message = error.response.data;
        } else if (error?.message) {
          message = error.message;
        }
        toast.error(message);
      });
  };

  handleChangeFormSearchService = (searchRegisterService) => {
    this.searchRegisterService = {
      ...this.searchRegisterService,
      ...searchRegisterService,
    };
    this.pagingRegisterService();
  };

  handleChangeFormSearchServiceAdvice = (obj) => {
    this.searchListPaServiceRes = {
      ...this.searchListPaServiceRes,
      ...obj,
    };
    this.pagingRegisterServiceAdvice();
  };

  handleOpenCreateOrEditServicePopup = async (serviceRegister) => {
    if (Boolean(serviceRegister)) {
      getHospitalBedSVRequestById(serviceRegister?.id).then(({ data }) => {
        data.totalAmount = data?.quantity * data?.price;
        if (data?.taxPercent) data.taxPercent = data?.taxPercent?.toString();
        if (data?.service) {
          data.groupId = data?.service?.serviceGroup;
          let feeItem = getPriceTypeService(
            data?.service?.patientTypeService,
            data?.service?.serviceFeeList
          );
          //console.log("feeItem", feeItem);
          data.patientTypeService = {
            ...feeItem?.patientTypeService,
            price: feeItem?.price,
          };
          data.groupId = data?.service?.serviceGroup;
        }
        this.initRegisterService = data;
        this.openCreateOrEditServicePopup = true;
      });
    } else {
      this.initRegisterService = { ...new RegisterService() };
      this.openCreateOrEditServicePopup = true;
    }
  };

  handleOpenAddServiceAdvicePopup = async (obj) => {
    this.searchListPaServiceRes = { ...this.searchListPaServiceRes, ...obj };
    this.pagingRegisterServiceAdvice();
    this.openAddServiceAdvicePopup = true;
  };

  handleAddServiceAdvicePopup = async (data, patient, customerSourceWalkIn) => {
    let currentConsultant = patient?.currentConsultant;
    let currentTelesale = patient?.currentTelesale || patient?.currentTelesale2;
    let { service, paiPatientTypeService, ...ortherData } = data;
    let feeItem;
    if (paiPatientTypeService && service?.serviceFeeList?.length > 0) {
      feeItem = service?.serviceFeeList?.find(
        (el) => el?.patientTypeService?.id === paiPatientTypeService?.id
      );
    } else {
      feeItem =
        service?.serviceFeeList?.length > 0
          ? getPriceTypeService(
            data?.patientTypeService,
            service?.serviceFeeList
          )
          : null;
    }

    ortherData.taxPercent = feeItem?.serviceVAT?.vatPercent;
    ortherData.price = feeItem?.price;
    ortherData.priceWithTax = feeItem?.vatIncluded;
    ortherData.totalAmount = feeItem?.price * data?.quantity;

    let revenueAllocations = service?.revenueAllocations;
    if (revenueAllocations) {
      let staffRevenues = revenueAllocations?.map((el) => ({
        position: el?.position,
        percentRevenue: el?.commissionRate,
        source: patient?.currentPatientSource
          ? patient?.currentPatientSource
          : customerSourceWalkIn,
        staff:
          currentConsultant?.position?.code === el?.position?.code
            ? currentConsultant
            : currentTelesale?.position?.code === el?.position?.code
              ? currentTelesale
              : null,
      }));
      console.log("staffRevenues", staffRevenues);
      ortherData.staffRevenues = staffRevenues;
    } else {
      ortherData.staffRevenues = [];
    }
    ortherData.patientTypeService = {
      ...feeItem?.patientTypeService,
      price: feeItem?.price,
    };

    let taxPercent = feeItem?.serviceVAT?.vatPercent?.toString() || 0;
    ortherData.taxPercent = taxPercent;

    let taxTotal;
    if (feeItem?.vatIncluded) {
      taxTotal =
        ((feeItem?.price * data?.quantity - data?.discount) /
          (+taxPercent + 100)) *
        +taxPercent;
    } else {
      taxTotal =
        (feeItem?.price * data?.quantity - data?.discount) *
        ((+taxPercent || 0) / 100);
    }

    ortherData.taxTotal = taxTotal;

    this.initRegisterService = { ...ortherData, service };
    this.openUpdateServiceAdvicePopup = true;
  };

  handleCloseCreateOrEditServicePopup = () => {
    this.openCreateOrEditServicePopup = false;
    this.initRegisterService = { ...new RegisterService() };
  };

  handleCloseAddServiceAdvicePopup = () => {
    this.openAddServiceAdvicePopup = false;
    this.searchListPaServiceRes = {
      ...new SearchObject(),
      fromDate: new Date(),
      toDate: new Date(),
    };
  };

  handleCloseUpdateServiceAdvicePopup = () => {
    this.openUpdateServiceAdvicePopup = false;
  };

  handleOpenConfirmDelete = (id) => {
    this.openConfirmDelete = id;
  };

  handleDeleteService = async () => {
    return await voidSvitemAndOrther(this.openConfirmDelete)
      .then(({ data }) => {
        this.openConfirmDelete = null;
        if (data?.responseStatus === false) {
          setTimeout(() => {
            this.openConfirmDeleteMessage = data?.responseDetail;
          }, 500);
          return;
        } else {
          toast.success("Xóa dịch vụ thành công");
          this.pagingRegisterService();
        }
      })
      .catch((error) => {
        console.error(error);
        let message = "Xóa dịch vụ có lỗi";
        if (error?.response?.data?.message) {
          message = error.response.data.message;
        } else if (typeof error?.response?.data === "string" && error.response.data) {
          message = error.response.data;
        } else if (error?.message) {
          message = error.message;
        }
        toast.error(message);
      });
  };

  handleCloseConfirmMessage = () => {
    this.openConfirmMessage = null;
  };

  handleCloseDeleteConfirmMessage = () => {
    this.openConfirmDeleteMessage = null;
  };

  handleOpenRegisterServiceHistoryPopup = () => {
    this.openRegisterServiceHistoryPopup = true;
  };

  handleCloseRegisterServiceHistoryPopup = () => {
    this.openRegisterServiceHistoryPopup = false;
  };

  handleChangeFormSearchRegisterServiceHistory = (searchRegisterServiceHistory) => {
    this.searchRegisterServiceHistory = {
      ...this.searchRegisterServiceHistory,
      ...searchRegisterServiceHistory,
    };
    this.fetchPagingRegisterServiceHistory();
  };

  fetchPagingRegisterServiceHistory = async () => {
    return await pagingRegisterServiceHistory({
      ...this.searchRegisterServiceHistory,
    })
      .then(({ data }) => {
        this.dataRegisterServiceHistory = data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu lịch sử dịch vụ có lỗi");
      });
  };

  setSelectRegisterServiceId = (id) => {
    this.selectRegisterServiceId = id;
  };

  resetStore = () => {
    this.searchRegisterService = {
      ...new SearchObject(),
      fromDate: new Date(new Date().getFullYear(), 0, 1),
      toDate: new Date(),
    };
    this.pageRegisterService = new PageResponse();
    this.openCreateOrEditServicePopup = false;
    this.initRegisterService = { ...new RegisterService() };
    this.openConfirmMessage = null;
    this.dataRegisterService = new PageResponse();
    this.searchListPaServiceRes = {
      ...new SearchObject(),
      fromDate: new Date(),
      toDate: new Date(),
    };
  };

  resetPopupStore = () => {
    this.initRegisterService = { ...new RegisterService() };
    this.openCreateOrEditServicePopup = false;
  };
}
